import { Component, OnInit, OnDestroy,ViewChild,ElementRef,AfterViewInit  } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { page }  from '../class/status';
import { menulist }  from '../class/status';
import { environment } from '../../../environments/environment';
import * as moment from 'moment';
import { Dep } from '../class/auth';
import { ToastComponent } from "../../layout/toast/toast.component";
import Swal from 'sweetalert2';


@Component({
    selector: 'app-announcement',
    templateUrl: './announcement.component.html',
    styleUrls: ['./announcement.component.css']
})
export class AnnouncementComponent implements OnInit, OnDestroy {

    private boundResizeHandler = () => { this.checkDeviceType(); };

    ngOnDestroy(): void {
        window.removeEventListener('resize', this.boundResizeHandler);
    }
    @ViewChild(ToastComponent, { static: true }) toastComponent: ToastComponent;

    @ViewChild('carousel', { static: false }) carousel!: ElementRef;
    isDesktop: boolean;

    winningImage: string | null = null;

    imagePrice: any[] = [
      {name: ''},
    ];

    PriceMember: any[] = [];
    AllPriceMember: any[] = [];


    imageA: any[] = [
      {url: 'https://via.placeholder.com/100?text=A',class:'imga',name:'A'},
      {url: 'https://via.placeholder.com/100?text=B',class:'imgb',name:'B'},
      {url: 'https://via.placeholder.com/100?text=C',class:'imgc',name:'C'},
      {url: 'https://via.placeholder.com/100?text=D',class:'imgd',name:'D'},
      {url: 'https://via.placeholder.com/100?text=E',class:'imge',name:'E'}
    ];
    imageB: any[] = [
      {url: 'https://via.placeholder.com/100?text=F',class:'imgf',name:'F'},
      {url: 'https://via.placeholder.com/100?text=G',class:'imgg',name:'G'},
      {url: 'https://via.placeholder.com/100?text=H',class:'imgh',name:'H'},
      {url: 'https://via.placeholder.com/100?text=I',class:'imgi',name:'I'},
      {url: 'https://via.placeholder.com/100?text=J',class:'imgj',name:'J'}
    ];
    imageC: any[] = [
      {url: 'https://via.placeholder.com/100?text=K',class:'imgk',name:'K'},
      {url: 'https://via.placeholder.com/100?text=L',class:'imgl',name:'L'},
      {url: 'https://via.placeholder.com/100?text=M',class:'imgm',name:'M'},
      {url: 'https://via.placeholder.com/100?text=N',class:'imgn',name:'N'},
      {url: 'https://via.placeholder.com/100?text=O',class:'imgo',name:'O'}
    ];
    imageD: any[] = [
      {url: 'https://via.placeholder.com/100?text=P',class:'imgp',name:'P'},
      {url: 'https://via.placeholder.com/100?text=Q',class:'imgq',name:'Q'},
      {url: 'https://via.placeholder.com/100?text=R',class:'imge',name:'R'},
      {url: 'https://via.placeholder.com/100?text=S',class:'imgs',name:'S'},
      {url: 'https://via.placeholder.com/100?text=T',class:'imgt',name:'T'}
    ];
    intervalId: any;
    time :any={};
    data:any=[];
    time_info:any=-1;
    top_info:any={};
    link:string = environment.link;
    edit_data:any={story_active_id:'-2',id:'-1',title:'',start_dt:'',end_dt:'',target_type:'1',status:1,content:'',type:'1',category:'1',
                    os:'0',gender:'0',identity:'999',show_popup:'0',show_banner:'0',show_list:'1',link_type:'0',route_sign:'0',external_url:'',btn_name:'',route_path:'',
                    btn_url:'',competition_type:'1',competition_count_type:'1',gift:'0',competition_threshold:0,sort_score:5,is_enable:0,lv:'',lotterylv:'',identity_listItems:{"1": true, "2": true, "3": true, "7": true},selectedItems:{},
                    giftdetailItems:{},bagdetailItems:{},rewards:[],lvTotal:[],
                    lotteryrewards:{open_type:1,lottery:[{ type: 1, name: '',lv:'1', target: '', diamond: 0, des: '', open: false }],
                    invoice:[{ type: 1, name: '',lv:'1', target: '', diamond: 0, des: '', open: false ,limit:1},{ type: 1, name: '',lv:'1', target: '', diamond: 0, des: '', open: false,limit:2 },{ type: 1, name: '',lv:'1', target: '', diamond: 0, des: '', open: false,limit:3 },{ type: 1, name: '',lv:'1', target: '', diamond: 0, des: '', open: false,limit:30 },{ type: 1, name: '',lv:'1', target: '', diamond: 0, des: '', open: false,limit:50 },{ type: 1, name: '',lv:'1', target: '', diamond: 0, des: '', open: false,limit:100 }]},
                    tmp_img_b64:'',tmp_img_b64_ban:'',giftdetail:[],selectedGifts:[],giftSelectdetail:[],giftNdetail:[]
                }
    user:any=[];
    loading:boolean=true;
    show_bagitem:boolean = false;//公告頁內切換到「背包道具管理」
    ImgType:boolean=false;
    pageobj:page = {page:0,count:20,total_count:0};
    pageobj2:page = {page:0,count:8,total_count:0};
    pageobj3:page = {page:0,count:10,total_count:0};
    menu_list:menulist = [{id:'2',name:'公告設定'}];
    pageobjstr:string=JSON.parse(JSON.stringify(this.pageobj))
    pageobjstr2:string=JSON.parse(JSON.stringify(this.pageobj2))
    pageobjstr3:string=JSON.parse(JSON.stringify(this.pageobj3))
    competition_threshold:0;
    timeset = [{ type:1 , name: "過去7天", num: -7 }, { type:1 , name: "昨天到今天", num: -1 },{ type:2 , name: "上個月", num: -1 }, { type:2 , name: "上上個月", num: -2 },{ type:3 , name: "昨天", num: -1 }];
    limitset = []; //[{ type:1,min:7,max:10 }]
    reward_status = ['未派獎','已派獎'];
    search_user = [];
    urltoken:string = '';

    items: any[] = [
      { id: '-1', name: '背包物品' },
      { id: '-2', name: '背包物品+禮物' },
      { id: '0', name: '官方活動' },
      { id: '1', name: 'APP儲值' },
      { id: '2', name: '文字' },
      { id: '3', name: '語音' },
      { id: '4', name: '解鎖相簿' },
      { id: '5', name: '推薦碼' },
      { id: '6', name: '視訊' },
      { id: '7', name: '家族貢獻' },
      { id: '8', name: '遊戲' },
      { id: '9', name: '簽到' },
      { id: '10', name: '禮物' },
      { id: '11', name: '網站儲值' },
      { id: '12', name: '直播' },
      { id: '13', name: '約會' },
      { id: '14', name: '額外獎勵' },
      { id: '15', name: '聊天室紅包' },
      { id: '16', name: '語音房' },
    ];

    gift_list:menulist=[
        {id:'0',name:'請選擇禮物名稱'},
    ];

    bag_list:menulist=[];

    lottery_type = 1;


    route_sign_list:menulist=[
        {id:'0',name:'請選擇類型'},
        // {id:'1',name:'打開 App'},
        // {id:'2',name:'探索頁-最新'},
        // {id:'3',name:'動態頁-熱門'},
        // {id:'4',name:'動態頁-私密話題'},
        // {id:'5',name:'動態明細內頁'},
        // {id:'6',name:'對象聊天室'},
        // {id:'7',name:'通話紀錄-未接來電'},
        // {id:'8',name:'收益及聊天費率'},
        // {id:'9',name:'提領紀錄頁'},
        // {id:'10',name:'交易紀錄頁'},
        // {id:'11',name:'個人頁'},
        // {id:'12',name:'偷看列表(plan)'},
        // {id:'13',name:'兌換與邀請獎勵'},
        // {id:'14',name:'女性收益報表'},
        // {id:'16',name:'聊天列表'},
        // {id:'18',name:'訊息管理中心帳號切換'},
    ];


    category_list:menulist=[
      {id:'1',name:'請選擇類型'},
      {id:'11',name:'一般'},
      {id:'12',name:'更新'},
    ];

    category_list1:menulist=[
      {id:'1',name:'請選擇類型'},
      {id:'21',name:'個人'},
      {id:'22',name:'競賽'},
      {id:'23',name:'儲值'},
      {id:'24',name:'外部直播'},
      {id:'25',name:'內部直播'},
      {id:'26',name:'廣告'},
      {id:'27',name:'動態主題'},
      {id:'28',name:'摸彩活動'},
      {id:'29',name:'語音視訊'},
    ];


    identity_list:menulist=[
        // {id:'0',name:'未限制'},
        // {id:'0',name:'簽約員工'},
        {id:'1',name:'一般用戶'},
        {id:'2',name:'內部員工'},
        {id:'3',name:'經紀成員'},
        {id:'7',name:'外部經紀'},
        // {id:'4',name:'業配人員'},
        // {id:'5',name:'陪聊'},
        // {id:'6',name:'內部經紀'},
        // {id:'99',name:'官方帳號'},
    ];

    tcontent = [
        {title:'類型',content:'typeName'},
        {title:'名稱',content:'title'},
        {title:'Banner圖',content:'banner_pic',type:3},
        {title:'彈跳視窗圖',content:'popup_pic',type:3},
        {title:'開始時間',content:'start_dt',css:'min-width: 80px;',sort:'start_dt'},
        {title:'結束時間',content:'end_dt',css:'min-width: 80px;',sort:'end_dt'},
        {title:'排序分數',content:'sort_score',css:'min-width: 120px;',sort:'sort_score'},
        {title:'狀態',content:'is_enable',type:3},
        {title:'操作',content:'gg',type:3},
    ];


    tcontent2 = [];
    dataItem:any = [];
    dataDetail = [];


    announcement_list:menulist = [
        {id:'0',name:'全部'},
        {id:'11',name:'公告 - 一般'},
        {id:'12',name:'公告 - 更新'},
        {id:'21',name:'活動 - 個人'},
        {id:'22',name:'活動 - 競賽'},
        {id:'23',name:'活動 - 儲值'},
        {id:'24',name:'活動 - 外部直播'},
        {id:'25',name:'活動 - 內部直播'},
        {id:'26',name:'活動 - 廣告'},
        {id:'27',name:'活動 - 動態主題'},
        {id:'28',name:'活動 - 摸彩活動'},
    ]


    announcement_status = '0';

    announc_isenablelist:menulist = [
        {id:'-3',name:'全部'},
        {id:'-2',name:'強制下架'},
        {id:'-1',name:'已過期'},
        {id:'0',name:'待上架'},
        {id:'1',name:'上架中'},
    ]

    announc_isenablelist_status = '-3';

    sort_obj:any = {column:'sum_diamond',sort:'0'};

    sort_obj1:any = {column:'start_dt',sort:'0'};

    annoucestatuses = [
        "強制下架",
        "已過期",
        "待上架",
        "上架中"
    ];

    story_active_list = [];

    user_search = [];

    btnstatus = 0;

    nowimagePrice = '';

    luckyitem = [];
    preurl:string = '';

    // 競賽等級/門檻設定（user_rank / user_rank_lv），依公告 aid 綁定
    rank_detail_obj = {diamond_start:0,diamond_end:100000,once_reward:0,name:'',real_info:'1'};
    rank_data:any = this.empty_rank();

    constructor(
      public httpClient: HttpClient,
    ) { }

    ngAfterViewInit() {
        console.log(123);
    }


    ngOnInit(): void {
      this.user = Dep.user;
      this.init_time();
      this.checkDeviceType();
      window.addEventListener('resize', this.boundResizeHandler);
    }

    exportexcel(item){
        this.preurl = environment.serverurl;
        this.urltoken = this.preurl+"/export_excel.php?limit=true&aid="+item.id+"&token="+Dep.token+"&time="+Date.now()+'&type=2';
        window.open( this.urltoken, '_blank');
    }

    //隨機人物,中獎位置,中獎獎項
    replaceImageWithPrice(imageArray: any[] , status, n = -1) {

        for (let i = 0; i < imageArray.length; i++) {

            const randomPriceIndex = Math.floor(Math.random() * this.AllPriceMember.length);

            imageArray[i].url = this.AllPriceMember[randomPriceIndex].profile_pic;
            imageArray[i].name = this.AllPriceMember[randomPriceIndex].name;

            if(status == 1){
                imageArray[4].url = this.PriceMember[n].profile_pic;
                imageArray[4].name = this.PriceMember[n].name;
            }

        }
    }


    startLottery(n = 0) {
        if (this.PriceMember[n] == undefined) {
            this.btnstatus = 2;
            return;
        }

        if (this.imagePrice[n].status == 0) {
            this.btnstatus = 1;
            let index = 0;
            const carousel = this.carousel.nativeElement;

            if (n != 0) {
                this.replaceImageWithPrice(this.imageA, 0);
                this.replaceImageWithPrice(this.imageB, 0);
                this.replaceImageWithPrice(this.imageC, 1,n);
                this.replaceImageWithPrice(this.imageD, 0);
                this.nowimagePrice = this.imagePrice[n].name;

                // 重置 transform 属性
                carousel.style.transform = `translateX(0px)`;
            }

            // 设置 transition 持续时间（减少持续时间以加速动画）
            const moveSpeed = 200; // 200ms for each transition
            carousel.style.transition = `transform ${moveSpeed / 1000}s linear`;

            // 使用较短的间隔时间
            this.intervalId = setInterval(() => {
                carousel.style.transform = `translateX(-${index * 110}px)`;
                index++;
            }, moveSpeed); // 设置为与 transition 持续时间相同或更短

            setTimeout(() => {
                clearInterval(this.intervalId);
                setTimeout(() => {
                    setTimeout(() => {
                        this.imagePrice[n].status = 1;
                        this.update_show(this.luckyitem,n);
                        this.startLottery(n + 1);
                    }, 1000);
                }, 500);
            }, 3000);
        } else {
            this.startLottery(n + 1);
        }
    }

    update_show(item,n){

        // type:1 更新獎項顯示狀況
        const body = {type:2,id:item.id,num:n};
        this.httpClient.post<any>("/customer_service/get_lottery_acitve_list.php",body).subscribe(res => {
          console.log(res);
        }, error => {
          console.log(error);
        });

    }




    callitem(item,rewas,n){


    // 檢查是否已存在
    if(this.user_search[n] == undefined){
        this.user_search[n] = [];
    }

    if(this.user_search[n].length > 0){

        Swal.fire({
            title: "一個獎項只能內定一個用戶!",
            icon: "error"
        });

    }else{
        let exists = this.user_search[n].some(user => user.id === item.id && user.name === item.name);

        if (!exists) {
            this.user_search[n].push(item);
            rewas.target = this.user_search[n];

        }
    }

  }

  clearbtnuser(i,n,rewas){
    this.user_search[n].splice(i, 1);
    rewas.target = this.user_search[n];
  }

    init_time(){
        let default_status = true;
        if(this.time_info!=-1){
            const tmp = this.time_info.split("_");
            if(tmp.length==4){
                default_status = false;
                this.time.start = tmp[0]
                this.time.end = tmp[1]


                this.time.startDate = moment(tmp[0]);
                this.time.endDate = moment(tmp[1]);

            }
        }

        if(default_status){
          this.time.startDate = moment().add(7, 'days').startOf('day');
          this.time.endDate = moment().add(14, 'days').startOf('day');

          this.time.start = moment(this.time.startDate)
          this.time.end = moment(this.time.endDate)
        }


        this.init_list();
        this.gifts_list();
    }

    dateTime(data){
        this.time = {
            startDate: data.start_dt, // 设置默认日期和时间
            endDate: data.end_dt // 设置默认日期和时间
          };
    }

    addReward(LV): void {

        let newObj = { name: '', diamond: '', rank: '', num: '' };

        let targetObject = this.edit_data.rewards.find(obj => obj.hasOwnProperty(LV));

        if (targetObject) {
          targetObject[LV].push(newObj);
        }

    }

    addLotteryReward(): void {
        let ldnum = this.edit_data.lotteryrewards.lottery.length + 1;
        let newObj = { type: 1, name: '',lv:ldnum, target: '', diamond: 0, des: '', open: false };
        this.edit_data.lotteryrewards.lottery.push(newObj);
    }

    addLv(): void {

        let temp = this.edit_data.lv;

        if(temp == '' || temp == undefined){
            return alert('LV不能為空');
        }

        let tempReward = { [temp]: [{ name: '', diamond: '', rank: '', num: '' }] };
        if (!this.edit_data.lvTotal.includes(temp)) {
            this.edit_data.lvTotal.push(temp);
            this.edit_data.rewards.push(tempReward)
        }else{
            alert('已存在LV'+temp);
        }
    }

    cancelReward(n,i): void {

        let targetObject = this.edit_data.rewards.find(obj => obj.hasOwnProperty(i));

        if (targetObject && targetObject[i]) {
          targetObject[i].splice(n, 1);
        }

    }


    cancelLotteryReward(n): void {
        this.edit_data.lotteryrewards.lottery.splice(n, 1);

        //lv重新排列
        this.edit_data.lotteryrewards.lottery.forEach((v,i) => {
            this.edit_data.lotteryrewards[i].lv = i+1;
        });
    }

    get_story(){

        //category選擇動態主題打api
        if(this.edit_data.category == 27){
            const body = {};
            this.httpClient.post<any>("/customer_service/get_now_story_active.php",body).subscribe(res => {
                res.data.forEach(v => {
                    this.story_active_list = [];
                    let tmp = { id: v.id, name: v.description};
                    this.story_active_list.push(tmp);
                });

            }, error => {
                console.log(error);
            });
        }


    }

    get_default(){
        this.user_search = [];
        this.rank_data = this.empty_rank();
        this.edit_data = {story_active_id:'-2',id:'-1',title:'',start_dt:'',end_dt:'',target_type:'1',status:1,type:'1',category:'1',os:'0',gender:'0',identity:'',show_popup:'0',show_banner:'0',
                        show_list:'1',link_type:'0',route_sign:'0',external_url:'',btn_name:'',btn_url:'',competition_type:'0',route_path:'',
                        competition_count_type:'0',gift:'0',competition_threshold:0,sort_score:5,is_enable:0,lv:'',identity_listItems:{"1": true, "2": true, "3": true, "7": true},selectedItems:{},giftdetailItems:{},
                        bagdetailItems:{},rewards:[],lvTotal:[],lotteryrewards: {open_type:1,lottery:[{ type: 1, name: '',lv:'1', target: '', diamond: 0, des: '', open: false }],
                        invoice:[{ type: 1, name: '',lv:'1', target: '', diamond: 0, des: '', open: false,limit:1 },{ type: 1, name: '',lv:'1', target: '', diamond: 0, des: '', open: false,limit:2 },{ type: 1, name: '',lv:'1', target: '', diamond: 0, des: '', open: false ,limit:3},{ type: 1, name: '',lv:'1', target: '', diamond: 0, des: '', open: false,limit:30 },{ type: 1, name: '',lv:'1', target: '', diamond: 0, des: '', open: false,limit:50 },{ type: 1, name: '',lv:'1', target: '', diamond: 0, des: '', open: false,limit:100 }]},
                        tmp_img_b64:'',tmp_img_b64_ban:'',giftdetail:[],selectedGifts:[],giftNdetail:[]};
    }


    callback(pageobj:page){
      if(JSON.stringify(this.pageobj)!=JSON.stringify(pageobj)){
        this.pageobj = pageobj;
        this.init_list();
      }
    }

    callback3(pageobj:page){
        if(JSON.stringify(this.pageobj3)!=JSON.stringify(pageobj)){
          this.pageobj3 = pageobj;
          this.click(this.dataItem);
        }
      }

    onGiftCheckSelected() {
        const selectedGift = this.edit_data.giftdetailItems;

         // Remove key-value pairs with value of false or 0
        for (const key in selectedGift) {
            if (selectedGift.hasOwnProperty(key) && !selectedGift[key]) {
                delete selectedGift[key];
            }
        }
        this.edit_data.selectedGifts = [selectedGift];
        this.edit_data.giftSelectdetail = this.edit_data.giftdetail.filter(gift => {
            const giftId = gift.id.toString();
            return this.edit_data.selectedGifts[0].hasOwnProperty(giftId);
        });

    }


    onRangeSelected(type,value: any) {
      if(value.startDate){
        this.time.start =  moment(value.startDate).format('YYYY-MM-DD')
        this.time.end =  moment(value.endDate).format('YYYY-MM-DD')
      }
    }


    add(){


        if(this.edit_data.title == '' || this.edit_data.title == undefined){
            Swal.fire({
                title: "標題不為空!",
                icon: "error"
            });
        }else if(this.edit_data.content == '' || this.edit_data.content == undefined){
            Swal.fire({
                title: "內容不為空!",
                icon: "error"
            });

        }else{

            let tmpstatus = 0;

            if(this.edit_data.type == 2 && this.edit_data.category == 28){

                this.edit_data.lotteryrewards.lottery.forEach(v => {
                    if(v.type == 1 && v.diamond == 0){
                        Swal.fire({
                            title: "鑽石不能為0!",
                            icon: "error"
                        });
                        tmpstatus = 1;
                    }
                });

                this.edit_data.lotteryrewards.invoice.forEach(v => {
                    if(v.type == 1 && v.diamond == 0){
                        Swal.fire({
                            title: "鑽石不能為0!",
                            icon: "error"
                        });
                        tmpstatus = 1;
                    }
                });
            }

            if(tmpstatus == 0){
                const time = JSON.parse(JSON.stringify(this.time))
                this.loading = true;
                const body = {data:this.edit_data,now_range:time,tmp_img_b64:this.edit_data.tmp_img_b64,tmp_img_b64_ban:this.edit_data.tmp_img_b64_ban};
                this.httpClient.post<any>("/customer_service/update_announcement_active.php",body).subscribe(res => {
                    this.loading = false;
                    // 競賽：一併儲存等級/門檻設定（user_rank/user_rank_lv），aid 用後端回傳的公告 id
                    if(this.edit_data.type == 2 && this.edit_data.category == 22 && res && res.aid){
                        this.save_rank(res.aid);
                    }
                    this.toastComponent.showMessage('新增成功', 'success');
                    this.init_list();
                }, error => {
                    console.log(error);
                });
            }
        }

    }


    upload(event:any,num:any){
        let fileList: FileList = event.target.files;
        if(fileList.length > 0) {
            let file: File = fileList[0];
            var reader = new FileReader();
            reader.readAsDataURL(file);//读出 base64
            reader.onloadend = ((e)=>{
                if(num == '0'){
                    this.edit_data.tmp_img_b64 = e.target.result;
                }else{
                    this.edit_data.tmp_img_b64_ban = e.target.result;
                }
            });
        }
    }




    //組模彩選項
    getlottery(item){
        let lottery_config_arr = JSON.parse(item.lottery_config);
        this.edit_data.lotteryrewards = lottery_config_arr;

        this.edit_data.lotteryrewards.lottery?.forEach((v,n) => {
            if(v.target != ''){
                this.user_search[n] = [];

                this.search_user.forEach((val) => {
                    if(val.id == v.target){
                        this.user_search[n].push(val);
                    }
                })
            }

        });

        console.log('this.user_search',this.user_search);
    }

    default_person(rewas,n){

        // 檢查是否已存在
        if(this.user_search[n] == undefined){
            this.user_search[n] = [];
        }

        if(this.user_search[n].length > 0){

            Swal.fire({
                title: "一個獎項只能內定一個用戶!",
                icon: "error"
            });

        }else{
            const body = {default:1};
            this.httpClient.post<any>("/customer_service/get_announcement_acitve_list.php",body).subscribe(res => {
                this.user_search[n].push(res.default_user);
                rewas.target = this.user_search[n];

            }, error => {
                console.log(error);
            });
        }
    }


    init_list(){
        this.loading = true;
        const body = {page: this.pageobj.page,count:this.pageobj.count,now_range:this.time,announcestatus:this.announcement_status,sort_obj:this.sort_obj1,annis_enable:this.announc_isenablelist_status};
        this.httpClient.post<any>("/customer_service/get_announcement_acitve_list.php",body).subscribe(res => {
            this.loading = false;
            this.data = res.data;
            console.log('data',this.data)
            this.search_user = res.search_user;
            this.pageobj.total_count = res.total_count
            this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))
        }, error => {
            console.log(error);
        });
    }


    gifts_list(){
        this.loading = true;
        const body = {type: 1};
        this.httpClient.post<any>("/customer_service/get_gift_list.php",body).subscribe(res => {
            this.loading = false;
            this.gift_list = this.gift_list.concat(res.data.gift);
            this.bag_list = this.bag_list.concat(res.data.bag);

        }, error => {
            console.log(error);
        });
    }

    onGiftSelected(event:any){

        if (event == 0) {
            return;
        }

        const body = {type: 2 , id:event};
        this.httpClient.post<any>("/customer_service/get_gift_list.php",body).subscribe(res => {
            this.loading = false;
            const newData = res.data;

            // 檢查每一個新的禮物是否已經存在於 this.giftdetail 中
            this.edit_data.giftNdetail = [];
            for (const newItem of newData) {
                if (!this.edit_data.giftdetail.some(item => item.id === newItem.id)) {
                    // 如果不存在，則將其添加到陣列中
                    this.edit_data.giftdetail.push(newItem);
                }

                if (!this.edit_data.giftNdetail.some(item => item.id === newItem.id)) {
                    // 如果不存在，則將其添加到陣列中
                    this.edit_data.giftNdetail.push(newItem);
                }
            }

        }, error => {
          console.log(error);
        });
    }

    handleRankInput(lv,n,i){

        let s = this.edit_data.rewards[i][lv];

        if (Array.isArray(s)) {

            // 提取所有的 rank
            let ranks:any='';
            ranks = s.map(item => item.rank);

            // 利用 Set 來檢查是否有重複值
            let uniqueRanks = new Set(ranks);

            // 如果原始 ranks 的長度和 uniqueRanks 的長度不一樣，表示有重複值
            let hasDuplicates = ranks.length !== uniqueRanks.size;

            //暫時拿掉
            // if (hasDuplicates) {
            //     alert("LV"+lv+"排名有重複值");
            //     this.edit_data.rewards[i][lv][n].rank = '';
            // }
        }
    }

    copy(item){
            console.log('item',item);
        Swal.fire({
            title: "確定要複製"+item.title+"的公告嗎?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "確定",
            cancelButtonText: "取消"
        }).then((result) => {
            if (result.isConfirmed) {

                const body = {id:item.id,copy:1};
                this.httpClient.post<any>("/customer_service/get_announcement_acitve_list.php",body).subscribe(res => {
                    this.loading = false;
                    this.init_list();
                    this.toastComponent.showMessage(res.msg, 'success');
                }, error => {
                    Swal.fire({
                        title: "已複製!",
                        icon: "success"
                    });
                });
            }
        });

    }

    luckylist(item){

        this.luckyitem = item;

        // type:1 抓所有開獎用戶
        const body = {type:1,data:item};
        this.httpClient.post<any>("/customer_service/get_lottery_acitve_list.php",body).subscribe(res => {
            this.loading = false;
            if(res.status){
                this.PriceMember = res.lottery_user;
                this.AllPriceMember = res.all_lottery_user;
                this.replaceImageWithPrice(this.imageA,0);
                this.replaceImageWithPrice(this.imageB,0);
                this.replaceImageWithPrice(this.imageC,1,0);
                this.replaceImageWithPrice(this.imageD,0);
            }else{
                this.dataDetail = [];
            }
        }, error => {
          console.log(error);
        });

        this.lottery_type = 2;
        let lottery_config = JSON.parse(item.lottery_config);

        this.imagePrice = [];

        //初始按鈕為開獎完成
        this.btnstatus = 2;

        lottery_config.forEach(v => {

            if(v.show == 0){
                this.btnstatus = 0;
            }

            let tmp = {name:v.name,status:v.show};
            this.imagePrice.push(tmp);

        });

        this.nowimagePrice = this.imagePrice[0].name;

    }

    click(item){
        console.log('item',item.end_dt);
        this.lottery_type = 1;
        this.dataItem = item;
        const body = {data:item,page: this.pageobj3.page,count:this.pageobj3.count,sort_obj:this.sort_obj};
        this.httpClient.post<any>("/customer_service/get_announcement_acitve_list.php",body).subscribe(res => {
            this.loading = false;
            if(res.status){

                this.dataDetail = res.data;
                this.competition_threshold = res.competition_threshold;

                this.pageobj3.total_count = res.total_count
                this.pageobjstr3=JSON.parse(JSON.stringify(this.pageobj3))


                this.tcontent2 = [
                    {title:'姓名',content:'name',type:2},
                    {title:'大頭貼',content:'profile_pic',type:1},
                    {title:'分數',content:'sum_diamond',type:3,css:'min-width: 80px;',sort:'sum_diamond'},
                    {title:'是否符合資格',content:'qualifications',type:3},
                    {title:'狀態',content:'reward_status',replaceArr:this.reward_status},
                ];

            }else{
                this.dataDetail = [];
            }
            console.log('res',res);
        }, error => {
          console.log(error);
        });
    }

    handlesortdata( value: any ): void {
        this.sort_obj = value;
        this.click(this.dataItem);
    }

    handlesortdata1( value: any ): void {
        this.sort_obj1 = value;
        this.init_list();
    }

    handlepage(e){
        this.pageobj3.page = e;
        this.click(this.dataItem);
    }

    del(item){
        Swal.fire({
            title: "確定要刪除" + item.title + "的公告?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "刪除",
            cancelButtonText: "取消",
        }).then((result) => {
            if (result.isConfirmed) {

                const body = {id:item.id,del:1};
                this.httpClient.post<any>("/customer_service/get_announcement_acitve_list.php",body).subscribe(res => {
                    this.loading = false;
                    Swal.fire("已刪除完成!", "", "success");
                    this.init_list();
                    this.toastComponent.showMessage(res.msg, 'error');
                }, error => {
                  console.log(error);
                });

            }
        });

    }



    handleImageUpload(file: File,num:Number,type:Number): void {
        if(type == 1){
            var reader = new FileReader();
            reader.readAsDataURL(file);//读出 base64
            reader.onloadend = ((e)=>{
                if(num == 0){
                    this.edit_data.tmp_img_b64 = e.target.result;
                }else{
                    this.edit_data.tmp_img_b64_ban = e.target.result;
                }
            });
        }else{

            if(num == 0){
                this.edit_data.tmp_img_b64 = file;
            }else{
                this.edit_data.tmp_img_b64_ban = file;
            }
        }

    }

    handleRangeSelected( value: any ): void {

        let  eventDate = value.event;

        if(eventDate.startDate){
            this.time.start =  moment(eventDate.startDate).format('YYYY-MM-DD HH:mm:ss')
            this.time.end =  moment(eventDate.endDate).format('YYYY-MM-DD HH:mm:ss')
            this.edit_data.start_dt =  moment(eventDate.startDate).format('YYYY-MM-DD HH:mm:ss')
            this.edit_data.end_dt =  moment(eventDate.endDate).format('YYYY-MM-DD HH:mm:ss')
        }
    }

    calculateNextDay(endDt: string): Date {
        // 將字串轉換為 Date 對象
        const endDate = new Date(endDt);

        // 加上一天
        endDate.setDate(endDate.getDate() + 1);

        // 設定時間為早上 8 點 7 分
        endDate.setHours(8, 7, 0, 0);

        return endDate;
    }

    empty_rank(){
        return {id:-1,name:'',gender:'2',can_choose_show:'1',tid:'1',aid:-1,past_aid:-1,recount_month:'0',
                start_count_date:'',dead_line_date:'',has:'0',
                detail:[{diamond_start:0,diamond_end:100000,once_reward:0,name:'',real_info:'1'}]};
    }

    // 編輯競賽時載入該活動(aid)既有的 user_rank + user_rank_lv
    load_rank(item){
        this.rank_data = this.empty_rank();
        if(!(item && item.type == 2 && item.category == 22)){ return; }
        this.rank_data.aid = item.id;
        if(!item.id || item.id == -1){ return; }
        const body = {aid:item.id,count:200};
        this.httpClient.post<any>("/get_user_rank.php",body).subscribe(res => {
            if(res && res.data && res.data.length > 0){
                const r = res.data[0];
                this.rank_data = {
                    id:r.id, name:r.name, gender:String(r.gender),
                    can_choose_show:String(r.can_choose_show==null?'1':r.can_choose_show),
                    tid:String(r.type||'1'), aid:item.id, past_aid:(r.past_aid==null?-1:r.past_aid),
                    recount_month:String(r.recount_month||'0'), start_count_date:r.start_count_date,
                    dead_line_date:r.dead_line_date, has:String(r.has||'0'),
                    detail:(r.detail||[]).map(d => ({id:d.id,name:d.name,diamond_start:d.diamond_start,
                        diamond_end:d.diamond_end,once_reward:d.once_reward,real_info:String(d.real_info),threshold:d.threshold}))
                };
                if(this.rank_data.detail.length == 0){
                    this.rank_data.detail = [{diamond_start:0,diamond_end:100000,once_reward:0,name:'',real_info:'1'}];
                }
            }
        }, error => { console.log(error); });
    }

    addRankLv(){
        this.rank_data.detail.push({...this.rank_detail_obj});
    }

    delRankLv(i){
        this.rank_data.detail.splice(i,1);
        if(this.rank_data.detail.length == 0){
            this.rank_data.detail.push({...this.rank_detail_obj});
        }
    }

    // 公告存檔後一併儲存等級/門檻（沿用既有 /update_user_rank.php，含「已有人獲得只能改名稱/門檻/獎勵」守門）
    save_rank(aid){
        if(!this.rank_data || !this.rank_data.name || !this.rank_data.detail || this.rank_data.detail.length == 0){ return; }
        const start = this.edit_data.start_dt ? moment(this.edit_data.start_dt).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
        const dead = this.edit_data.end_dt ? moment(this.edit_data.end_dt).subtract(1,'days').format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
        // 門檻以 diamond_start 為準，同步寫入 threshold（後端新增走 diamond_start、已有人獲得走 threshold）
        const detail = this.rank_data.detail.map(d => ({...d, threshold:d.diamond_start}));
        const payload = {
            id:this.rank_data.id, name:this.rank_data.name, gender:this.rank_data.gender,
            can_choose_show:this.rank_data.can_choose_show || '1', tid:'1', aid:aid,
            past_aid:(this.rank_data.past_aid==null?-1:this.rank_data.past_aid), recount_month:'0',
            start_count_date:start, dead_line_date:dead, detail:detail
        };
        this.httpClient.post<any>("/update_user_rank.php",{data:payload}).subscribe(res => {
            if(res && res.status){ this.toastComponent.showMessage('等級設定已儲存','success'); }
            else { this.toastComponent.showMessage((res && res.message) || '等級設定儲存失敗','error'); }
        }, error => { console.log(error); });
    }

    checkDeviceType() {
        if (window.innerWidth > 768) { // 假設768px是切換點
            this.isDesktop = true;
        } else {
            this.isDesktop = false;
        }
    }
}
